/**
 * Flow Hub feature configuration
 * 14/04/2026 - Created
 */
import { colorsConfig } from "../../../config/colors.config";
// ─── Colors ───────────────────────────────────────────────────────────────────

const { background, textPrimary, iconPrimary, iconSecondary } = colorsConfig;

// ─── Buttons ──────────────────────────────────────────────────────────────────

const BUTTON_BASE = {
    textTransform: "none",
    fontWeight: 500,
    borderRadius: 2,
    px: 1.75,
    py: 0.6,
    minHeight: 32,
} as const;

export const FLOW_HUB_BUTTON_PRIMARY_CONFIG = {
    ...BUTTON_BASE,
    color: "#ffffff",
    backgroundColor: "#f08728",
    "&:hover": { backgroundColor: "#b4641e" },
} as const;

export const FLOW_HUB_BUTTON_SECONDARY_CONFIG = {
    ...BUTTON_BASE,
    color: textPrimary,
} as const;

export const FLOW_HUB_BUTTON_TERTIARY_CONFIG = {
    ...BUTTON_BASE,
    color: "var(--fx-surface-texttertiary, #94A3B8)",
    backgroundColor: "var(--fx-surface-sunken, #F8FAFC)",
    "&:hover": { backgroundColor: "var(--fx-surface-sunken, #F8FAFC)" },
} as const;

// ─── Icons ────────────────────────────────────────────────────────────────────

const ICON_BASE = {
    padding: 0.75,
    borderRadius: 100,
    width: 34,
    height: 34,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
} as const;

export const FLOW_HUB_ICON_CONFIG = {
    iconPrimary: {
        ...ICON_BASE,
        color: iconPrimary,
        backgroundColor: `${iconPrimary}25`,
    },
    iconSecondary: {
        ...ICON_BASE,
        color: iconSecondary,
        backgroundColor: `${iconSecondary}25`,
    },
} as const;

// ─── Navbar ───────────────────────────────────────────────────────────────────

export const FLOW_HUB_NAVBAR_CONFIG = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0.7rem 1rem",
    backgroundColor: background,
    color: textPrimary,
    flexShrink: 0,
} as const;

// ─── Cards ────────────────────────────────────────────────────────────────────

export const FLOW_HUB_CARD_CONFIG = {
    display: "flex",
    flexDirection: "column",
    gap: 1.4,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    padding: "1rem",
    backgroundColor: colorsConfig.cardBg,
    color: textPrimary,
    minHeight: "150px",
    width: "100%",
    maxWidth: "320px",
    borderRadius: "3px",
    boxShadow: "none",
    transition: "transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out",
    "&:hover": {
        transform: "translateY(-2px)",
        boxShadow: "none",
    },
} as const;

// ─── Layout ───────────────────────────────────────────────────────────────────

export const FLOW_HUB_LAYOUT_CONFIG = {
    display: "flex",
    flexDirection: "column",
    gap: 1.6,
    justifyContent: "flex-start",
    alignItems: "flex-start",
    py: 1,
    px: 1.5,
} as const;
